module.exports = __webpack_public_path__ + "img/history.1f8936c2.svg";